import React from "react";
import { useMediaQuery } from "@mui/material";
import MobileNavbar from "./MobileNavbar";
import Navbar from "./NavBar";
import BottomNavBar from "./BottomNavBar";
import { useLocation } from "react-router-dom";

const ResponsiveCourseNavnarForDivices = () => {
  const isDesktop = useMediaQuery("(min-width:767px)");
  const location = useLocation();
  const isCourseDetailsPage = location.pathname.startsWith("/student/course/");
  return (
    <>
      {!isDesktop && !isCourseDetailsPage && (
        <>
          <MobileNavbar />
          <BottomNavBar />
        </>
      )}
      {isDesktop && <Navbar />}
    </>
  );
};

export default ResponsiveCourseNavnarForDivices;
